import { render, staticRenderFns } from "./ApprovalTemplates.vue?vue&type=template&id=745e492b"
import script from "./ApprovalTemplates.vue?vue&type=script&lang=js"
export * from "./ApprovalTemplates.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTemplates.vue?vue&type=style&index=0&id=745e492b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports